/* eslint-disable no-console */
import { KENTICO_TYPES } from 'common/consts/kentico';
import Client from './kenticoClient';

class CoreService {
  client = Client;

  async fetchCoreData() {
    try {
      const coreDataItems = await this.client.items()
        .type(KENTICO_TYPES.CORE)
        .depthParameter(5)
        .getPromise();

      if (coreDataItems.isEmpty) {
        return null;
      }
      return coreDataItems.lastItem;
    } catch (err) {
      console.log('Failed to fetch core data', err);
      return null;
    }
  }
}

export default new CoreService();



// WEBPACK FOOTER //
// ./src/services/Core.service.js